<template>
  <div class="drop-menu-wrapper bg-white">
    <div class="w-limit d-flex justify-content-between align-items-center">
      <div class="f-cont f-16 f-semi text-primary wrapper-content grid-auto" @click="$emit('action')" id="wr-cnt">
        <div class="bg-white" style="width: 20px; z-index: 2">
          <img src="@/assets/icons/outlet-blue.svg" alt="">
        </div>
        <div class="position-relative">
          <span id="text-content">{{ text }}</span>
        </div>
        <div class="bg-white" style="z-index: 2">
          <img src="@/assets/icons/chevron-rotate-down.svg" alt="">
        </div>
      </div>
      <div
          class="refresh-wrapper f-cont f-16 f-semi text-primary"
          @click="reload()"
      >
        <img src="@/assets/icons/refresh.svg" alt="">
        <span class="align-items-center">Refresh</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SODropdownMenu",
  props: {
    text: String
  },
  methods: {
    reload() {
      window.location.reload();
    },
    data() {
      return {
        interval,
      }
    },
    runningText() {
      let text = document.getElementById("text-content")
      let wrapper = document.getElementById("wr-cnt")

      if (text.textContent.length > 13 && window.screen.width < 500) {
        wrapper.classList.remove("grid-auto")
        wrapper.classList.add("grid-fixed")

        let elWidth = text.offsetWidth;
        let parentWidth = text.parentElement.offsetWidth;
        let flag = 0;

        this.interval = setInterval(() => {
          text.style.marginLeft = --flag + "px";

          if (elWidth === -flag) {
            flag = parentWidth;
          }
        }, 80);
      }
    }
  },
  mounted() {
    this.runningText()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>

<style scoped>
.drop-menu-wrapper {
  padding: 6px 20px;
}

.wrapper-content {
  display: grid;
  grid-column-gap: 4px;
  align-items: start;
}

.grid-fixed{
  grid-template-columns: 16px 100px 16px;
}
.grid-auto{
  grid-template-columns: 16px auto 16px;
}

.refresh-wrapper {
  display: flex;
  align-items: flex-start;
}

@media screen and (min-width: 500px) {
  .wrapper-content {
    grid-template-columns: 16px auto 16px;
  }
}

</style>